import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export interface CreateCampaignDataProps {
    title: string;
    active: boolean;
}

export const createCampaign = async (domain: string, data: CreateCampaignDataProps): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `campaigns`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: data,
        domain,
    });
}